import './App.css';
import TransformStream from './TranslationToggle'
function App() {
  return (
   <>
   <TransformStream></TransformStream>
   </>
  );
}

export default App;